import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/Page/PageTitle";
import PageWrapper from "../../../components/Page/PageWrapper";
import CustomReportsTable from "./CustomReportsTable/CustomReportsTable";

const CustomReports = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.customReports")} />
      <CustomReportsTable />
    </PageWrapper>
  );
};

export default CustomReports;
